import { ca } from '@cian/analytics';

export function trackInfrastructureShow() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Card',
    label: 'infrastructure',
    name: 'oldevent',
    useLastProducts: true,
  });
}
